import { Component } from 'react';
import { styles, colors } from './UI';

// Catches render-time errors so a single broken tab doesn't unmount the
// whole app (which previously left users at a white screen, forcing a
// logout/login to recover).
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    console.error('ErrorBoundary caught:', error, info);
    // Fire-and-forget POST to server log so we can debug without asking
    // the user to open DevTools.
    try {
      fetch('/api/errors', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message: String(error?.message || error),
          stack: String(error?.stack || ''),
          componentStack: String(info?.componentStack || ''),
          location: typeof window !== 'undefined' ? window.location.href : '',
          userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : ''
        })
      }).catch(() => {});
    } catch {}
  }

  reset = () => this.setState({ error: null, info: null });

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={{ ...styles.card, borderColor: colors.red, background: '#FEF2F2' }}>
        <h2 style={{ ...styles.h2, color: colors.red, marginTop: 0 }}>Something went wrong</h2>
        <p style={{ fontSize: 13, color: colors.charcoal }}>
          The page hit an error. The rest of the app is still working — go to another tab, or click Reset below to try again.
        </p>
        <pre style={{
          background: '#fff', border: `1px solid ${colors.border}`, borderRadius: 6,
          padding: 12, fontSize: 12, maxHeight: 240, overflow: 'auto', whiteSpace: 'pre-wrap'
        }}>
          {String(this.state.error?.stack || this.state.error?.message || this.state.error)}
        </pre>
        <button style={styles.btn} onClick={this.reset}>Reset</button>
      </div>
    );
  }
}
